import React, { FC } from 'react';
import VisaLogo from '../images/VisaLogo.png';

const VisaLogoMulti: FC<{ className: string }> = ({ className }) => {
  return <img src={VisaLogo} className={className} />;
};

export default VisaLogoMulti;
